import Vue from 'vue'
import VueRouter from 'vue-router'
import List from 'views/list/List.vue'
import topicList from 'views/list/topicList.vue'

Vue.use(VueRouter)

const Detail = () => import('views/list/Detail.vue');
const Publish = () => import('views/publish/Publish.vue');
const Profile = () => import('views/profile/Profile.vue');
const Comment = () => import('views/publish/Comment.vue');
const Result = () => import('views/publish/Result.vue');

const Cpublish = () => import('views/publish/Cpublish.vue');
const Npublish = () => import('views/publish/Npublish.vue');
const routes = [
  // {
  //   path: '/',
  //   name: 'List',
  //   component: List
  // },
  {
    path: '/list/:id',
    name: 'List',
    component: List
  },
  
  {
    path: '/topicList/:id/topic/:topic',
    name: 'topicList',
    component: topicList
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: Detail
  },
  {
    path: '/profile/:id',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/publish/:id',
    name: 'Publish',
    component: Publish
  },
  {
    path: '/cpublish/:id',
    name: 'Cpublish',
    component: Cpublish
  },
  {
    path: '/npublish/:id',
    name: 'Npublish',
    component: Npublish
  },
  {
    path: '/comment/:id',
    name: 'Comment',
    component: Comment
  },
  {
    path: '/result/:id',
    name: 'Result',
    component: Result
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
